import {
  Breadcrumb,
  DocumentIcon,
  ErrorAlert,
  LinkBtn,
  PageHero,
  SearchToggle,
  TableRowsPerPage,
} from "@";
import { useCanShow } from "@/shared/hooks";
import MultiSearch from "../components/MultiSearch";
import { LandingPagesGrid } from "../components/LandingPagesGrid";
import { useLandingPagesPage } from "../hooks/index";
import { cardZone } from "../../shared/cards";

const Page = () => {
  const {
    data,
    isLoading,
    error,
    totalItems,
    search,
    updateSearch,
    handleSearchSubmit,
    handleSearchReset,
    pg,
    updatePg,
    refetch,
    deleteHandler,
    togglePublish,
  } = useLandingPagesPage();

  const canEdit = useCanShow("editSitePages");

  return (
    <>
      <ErrorAlert reload={refetch} show={error} />
      <Breadcrumb links={[{ name: "صفحات الهبوط", link: "" }]} />

      <main className="table-card relative">
        <PageHero
          eyebrow="الموقع / صفحات الهبوط"
          title="صفحات الهبوط"
          count={totalItems}
          icon={DocumentIcon}
          hideCount={isLoading}
        >
          <TableRowsPerPage
            pagination={{ ...pg, rows: totalItems }}
            rowsPerPageOptions={[5, 10, 15, 25]}
            onRowsPerPageChange={(size: number) => updatePg({ size, page: 1 })}
          />

          {canEdit && <LinkBtn to="/website/landing-pages/create" create />}
          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        <MultiSearch
          search={search}
          onSubmit={handleSearchSubmit}
          updateSearch={updateSearch}
          onReset={handleSearchReset}
        />

          <div className={cardZone}>
            <LandingPagesGrid
              data={data}
              isLoading={isLoading}
              totalItems={totalItems}
              pg={pg}
              updatePg={updatePg}
              deleteHandler={deleteHandler}
              togglePublish={togglePublish}
            />
          </div>
        
      </main>
    </>
  );
};

export default Page;
